import rebaseLogo from '../assets/rebase-logo.svg';

const GREEN = '#1FA64A';
const INK = '#1F2A33';

// Hi-vis chevron — the warning-stripe motif from site signage, used as a light
// repeating background texture instead of the old legal "sparkle" flourishes.
const Chevron = ({ className, size = 22 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M2 15 12 5l10 10-3 0-7-7-7 7Z" fill={GREEN} fillOpacity="0.5" />
  </svg>
);

/**
 * Shared shell for the login / register screens.
 * Concrete background, hi-vis chevrons, centered logo + tagline, title.
 */
const AuthLayout = ({ title, altText, altLinkText, altLinkTo, LinkComponent, children }) => {
  const AltLink = LinkComponent;
  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-b from-[#f6f8f9] via-[#eef1f3] to-[#dfe4e8]">
      {/* Hazard-tape strip along the top */}
      <div
        className="absolute inset-x-0 top-0 h-2"
        style={{ backgroundImage: `repeating-linear-gradient(45deg, ${INK} 0 12px, ${GREEN} 12px 24px)` }}
        aria-hidden="true"
      />
      <Chevron className="absolute top-10 right-6" size={30} />
      <Chevron className="absolute top-20 left-8" size={26} />
      <Chevron className="absolute top-1/3 right-10" size={22} />
      <Chevron className="absolute top-1/2 left-6" size={30} />
      <Chevron className="absolute bottom-40 left-12" size={26} />
      <Chevron className="absolute bottom-24 right-8" size={30} />
      <Chevron className="absolute bottom-10 left-8" size={22} />

      <div className="relative mx-auto flex min-h-screen w-full max-w-md flex-col justify-center px-6 py-5">
        <div className="text-center">
          <img src={rebaseLogo} alt="Rebase" className="mx-auto h-16 w-auto sm:h-20" />
          <div className="mt-3 flex items-center justify-center gap-2">
            <span className="h-px w-6" style={{ background: GREEN }} />
            <span className="text-sm font-bold sm:text-base" style={{ color: INK }}>גיוס עובדי בניין ואנשי מקצוע</span>
            <span className="h-px w-6" style={{ background: GREEN }} />
          </div>

          <h1 className="mt-4 text-2xl font-extrabold text-gray-900">{title}</h1>

          {altLinkText && (
            <p className="mt-2 text-sm text-gray-600">
              {altText}{' '}
              <AltLink to={altLinkTo} className="font-semibold text-blue-600 hover:text-blue-500">
                {altLinkText}
              </AltLink>
            </p>
          )}
        </div>

        <div className="mt-5">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
